import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import Get from "../../Get";

function PreArticulosChinaCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_PRE_ARTICULOS = import.meta.env.VITE_URL_PRE_ARTICULOS;
  const URL_INVENTARIOS = import.meta.env.VITE_URL_INVENTARIOS;
  const URL_LINEAS = import.meta.env.VITE_URL_LINEAS;
  const URL_MARCAS = import.meta.env.VITE_URL_MARCAS;
  const URL_FAMILIAS = import.meta.env.VITE_URL_FAMILIAS;
  const URL_COLECCIONES = import.meta.env.VITE_URL_COLECCIONES;
  const URL_PROVEEDORES = import.meta.env.VITE_URL_PROVEEDORES;
  const URL_COLORES = import.meta.env.VITE_URL_COLORES;
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;
  const URL_ARTICULOS_PROPORCION =
    import.meta.env.VITE_URL_ARTICULOS_PROPORCION;

  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");
  const [piezasPorCaja, setPiezasPorCaja] = useState("");
  const [codigoSAT, setCodigoSAT] = useState("NA");
  const [codigoUnidad, setCodigoUnidad] = useState("PZ");
  const [observaciones, setObservaciones] = useState("NA");
  const [lineas, setLineas] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [colecciones, setColecciones] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [precioEsp, setPrecioEsp] = useState("");
  const [ano, setAno] = useState("");
  const [EAN, setEAN] = useState("");
  const [selectedLinea, setSelectedLinea] = useState("");
  const [selectedMarca, setSelectedMarca] = useState("");
  const [selectedFamilia, setSelectedFamilia] = useState("");
  const [selectedColeccion, setSelectedColeccion] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");

  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  const [modalColores, setModalColores] = useState(false);
  const toggleColores = () => setModalColores(!modalColores);
  const [arrayColores, setArrayColores] = useState([]);

  const [modalTallas, setModalTallas] = useState(false);
  const toggleTallas = () => setModalTallas(!modalTallas);
  const [arrayTallas, setArrayTallas] = useState([]);

  const [amounts, setAmounts] = useState([]);
  const [validaBoton, setValidaBoton] = useState(true);

  let hoy = new Date();
  hoy.setDate(hoy.getDate() - 3650);
  const year = hoy.getFullYear();
  const years = Array.from(new Array(40), (val, index) => index + year);

  const [lastChanged, setLastChanged] = useState(null);


  useEffect(() => {
    axios
      .get(URL_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allLineas = res.data;
        setLineas(allLineas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_MARCAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allMarcas = res.data;
        setMarcas(allMarcas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_FAMILIAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allFamilias = res.data;
        setFamilias(allFamilias);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLECCIONES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColecciones = res.data;
        setColecciones(allColecciones);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(`${URL_PROVEEDORES}Tipo/China`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColores = res.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
        const customSizeOrder = allTallas.map((t) => t.name);
        setCustomSizeOrder(customSizeOrder);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

 function coloresSeleccionados(checked, color) {
    if (checked) {
      setArrayColores([...arrayColores, { id: color._id, name: color.name }]);
    } else {
      const values = [...arrayColores];
      const indexToRemove = values.findIndex((t) => t.id === color._id);

      if (indexToRemove !== -1) {
        values.splice(indexToRemove, 1);
        setArrayColores(values);
      }
    }
  }

  function tallasSeleccionados(checked, talla) {
    if (checked) {
      setArrayTallas([...arrayTallas, { id: talla._id, name: talla.name }]);
    } else {
      const values = [...arrayTallas];
      const indexToRemove = values.findIndex((t) => t.id === talla._id);

      if (indexToRemove !== -1) {
        values.splice(indexToRemove, 1);
        setArrayTallas(values);
      }
    }
  }

  const saveArticulos = async (event) => {
    event.preventDefault();
    setValidaBoton(false);

    const arrayTallasOfIds = arrayTallas.map((talla) => talla.id);
    const arrayColoresOfIds = arrayColores.map((c) => c.id);

    let totalProporcion = amounts.length;

    if (piezasPorCaja == 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "You must add the proportion of pieces per box!",
      });
      setValidaBoton(true);
      return;
    }

    try {
      await axios
        .post(
          URL_PRE_ARTICULOS,
          {
            codigo,
            nombre,
            piezasPorCaja,
            costoUSD:0,
            costoMX:0,
            venta:0,
            utilidadP: 0,
            utilidadM: 0,
            lista1: 0,
            lista2: 0,
            lista3: 0,
            lista4: 0,
            observaciones,
            lineas: selectedLinea,
            marcas: selectedMarca,
            familias: selectedFamilia,
            colecciones: selectedColeccion,
            proveedores: selectedProveedor,
            ano,
            EAN,
            precioEsp: "Si",
            colores: arrayColoresOfIds,
            tallas: arrayTallasOfIds,
            codigoSAT,
            codigoUnidad,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )

        .then((data) => {
          amounts.map((a) => {
            axios
              .post(
                URL_ARTICULOS_PROPORCION,
                {
                  preArticulos: data.data._id,
                  cantidad: a.cantidad,
                  colores: a.colorId,
                  tallas: a.sizeId,
                  EAN: a.ean,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalProporcion = totalProporcion - 1;
                if (totalProporcion == 0) {
                  axios.post(
                    URL_LOGS,
                    {
                      tipo: "Crear Modelo",
                      detalle: `${nombre} ${codigo}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  );
                  Swal.fire("Good job!", "Created successfully", `success`);
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                }
              })
              .catch((error) => {
                console.log(error);
                setValidaBoton(true);
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
                });
              });
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
      });
      console.log(error);
    }
  };

 const handleInputChange = (sizeId, colorId, value, fieldType) => {
    const updatedAmounts = [...amounts];
    const existingEntryIndex = updatedAmounts.findIndex(
      (entry) => entry.sizeId === sizeId && entry.colorId === colorId
    );

    if (existingEntryIndex !== -1) {
      // Update existing entry
      if (fieldType === "amount") {
        updatedAmounts[existingEntryIndex].cantidad = value;
      } else if (fieldType === "ean") {
        updatedAmounts[existingEntryIndex].ean = value;
      }
    } else {
      // Create new entry with default values
      const newEntry = {
        sizeId: sizeId,
        colorId: colorId,
        tallas: sizeId,
        colores: colorId,
        cantidad: fieldType === "amount" ? value : 0,
        ean: fieldType === "ean" ? value : "",
      };
      updatedAmounts.push(newEntry);
    }

    setAmounts(updatedAmounts);

    // Calculate total for piezasPorCaja (only using the cantidad values)
    const totalAmount = updatedAmounts.reduce(
      (acc, curr) => acc + (parseFloat(curr.cantidad) || 0),
      0
    );

    setPiezasPorCaja(totalAmount);
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div className="card container">
          <h3 align="center">New China Pre Model</h3>
          {/* <Get/> */}
          <Form onSubmit={saveArticulos}>
            <Row>
              <Col md={3}>
                <Label>Model Number</Label>
                <Input
                  type="text"
                  placeholder="Code"
                  value={codigo}
                  required
                  onChange={(e) => {
                    setCodigo(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Name</Label>
                <Input
                  type="text"
                  placeholder="Name"
                  value={nombre}
                  required
                  onChange={(e) => {
                    setNombre(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label>Pieces Per Box</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={piezasPorCaja}
                  required
                  disabled
                />
              </Col>
              <Col md={3}>
                <Label>Barcode</Label>
                <Input
                  type="text"
                  placeholder="Barcode"
                  value={EAN}
                  required
                  onChange={(e) => {
                    setEAN(e.target.value);
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Line</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedLinea}
                  required
                  onChange={(e) => {
                    setSelectedLinea(e.target.value);
                  }}
                >
                  <option value="0">Select a Line</option>
                  {lineas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Brand</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedMarca}
                  required
                  onChange={(e) => {
                    setSelectedMarca(e.target.value);
                  }}
                >
                  <option value="0">Select a Brand</option>
                  {marcas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Family</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedFamilia}
                  required
                  onChange={(e) => {
                    setSelectedFamilia(e.target.value);
                  }}
                >
                  <option value="0">Select a Family</option>
                  {familias
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Collection</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedColeccion}
                  required
                  onChange={(e) => {
                    setSelectedColeccion(e.target.value);
                  }}
                >
                  <option value="0">Select a Collection</option>
                  {colecciones
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
              <Col md={3}>
                <Label>Year</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={ano}
                  required
                  onChange={(e) => {
                    setAno(e.target.value);
                  }}
                >
                  <option value="0">Select a Year</option>
                  {years.map((a) => {
                    return <option value={a}>{a}</option>;
                  })}
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Supplier</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedProveedor}
                  required
                  onChange={(e) => {
                    setSelectedProveedor(e.target.value);
                  }}
                >
                  <option value="0">Select a Supplier</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Add Colors
                </Label>
                <br />
                <Button
                  color="success"
                  id="Colores"
                  onClick={(e) => toggleColores()}
                >
                  <i class="fas fa-palette fa-2x "></i>
                </Button>
              </Col>

              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Add Sizes
                </Label>
                <br />
                <Button
                  color="success"
                  id="Tallas"
                  onClick={(e) => toggleTallas()}
                >
                  <i class="fas fa-ruler-horizontal fa-2x "></i>
                </Button>
              </Col>
            </Row>
            <br />

            <Row className="w-full">
              <div className="bg-white shadow-md rounded-lg overflow-hidden border border-gray-200 w-full">
                <div className="p-6 bg-gray-50">
                  <Label className="text-xl font-semibold text-gray-800 mb-4 block">
                    Proportion
                  </Label>

                  {/* Enhanced scrollable container */}
                  <div
                    style={{
                      width: "100%",
                      overflowX: "auto",
                      WebkitOverflowScrolling: "touch",
                      display: "block",
                      maxWidth: "100%",
                    }}
                  >
                    <table
                      style={{
                        minWidth: "1200px",
                        width: "100%",
                        borderCollapse: "collapse",
                      }}
                    >
                      <thead>
                        {/* Size Names Row */}
                        <tr>
                          <th
                            className="border py-3 px-4 text-center font-medium text-gray-600"
                            style={{
                              width: "200px",
                              position: "sticky",
                              left: 0,
                              zIndex: 10,
                              backgroundColor: "white",
                              color: "gray",
                            }}
                          ></th>
                          {[...arrayTallas]
                            .sort((a, b) => {
                              const indexA = customSizeOrder.indexOf(a.name);
                              const indexB = customSizeOrder.indexOf(b.name);
                              if (indexA === -1 && indexB === -1) return 0;
                              if (indexA === -1) return 1;
                              if (indexB === -1) return -1;
                              return indexA - indexB;
                            })
                            .map((size) => (
                              <th
                                key={size.id}
                                className="border py-2 px-4 text-center font-medium text-gray-600"
                                colSpan="2"
                              >
                                <div
                                  className="text-lg border border-gray-300 rounded-t-lg py-2 bg-gray-100"
                                  style={{ color: "gray" }}
                                >
                                  {size.name}
                                </div>
                              </th>
                            ))}
                        </tr>

                        {/* Column Headers Row */}
                        <tr>
                          <th
                            className="border py-2 px-4 text-left font-medium text-gray-500"
                            style={{
                              position: "sticky",
                              left: 0,
                              zIndex: 10,
                              backgroundColor: "white",
                              color: "gray",
                            }}
                          ></th>
                          {[...arrayTallas]
                            .sort((a, b) => {
                              const indexA = customSizeOrder.indexOf(a.name);
                              const indexB = customSizeOrder.indexOf(b.name);
                              if (indexA === -1 && indexB === -1) return 0;
                              if (indexA === -1) return 1;
                              if (indexB === -1) return -1;
                              return indexA - indexB;
                            })
                            .map((size) => (
                              <React.Fragment key={`header-${size.id}`}>
                                <th
                                  className="border py-2 px-1 text-center text-xs font-medium text-gray-500 bg-gray-50"
                                  style={{
                                    width: "80px",
                                    color: "gray",
                                  }}
                                >
                                  QUANTITY
                                </th>
                                <th
                                  className="border py-2 px-3 text-center text-xs font-medium text-gray-500 bg-gray-50"
                                  style={{
                                    width: "240px",
                                    color: "gray",
                                  }}
                                >
                                  BARCODE
                                </th>
                              </React.Fragment>
                            ))}
                        </tr>
                      </thead>
                      <tbody>
                        {arrayColores.map((color, colorIndex) => (
                          <tr
                            key={color.id}
                            className={`${colorIndex % 2 === 0 ? "bg-white" : "bg-gray-50"
                              } hover:bg-gray-100 transition-colors`}
                          >
                            <td
                              className="border py-3 px-4 text-gray-700 font-medium"
                              style={{
                                position: "sticky",
                                left: 0,
                                zIndex: 5,
                                backgroundColor:
                                  colorIndex % 2 === 0 ? "white" : "#f9fafb",
                                color: "gray",
                              }}
                            >
                              <div className="flex items-center">
                                <div
                                  className="w-4 h-4 rounded-full mr-3"
                                  style={{
                                    backgroundColor: color.name.toLowerCase(),
                                    color: "gray",
                                  }}
                                ></div>
                                <span className="uppercase">{color.name}</span>
                              </div>
                            </td>
                            {[...arrayTallas]
                              .sort((a, b) => {
                                const indexA = customSizeOrder.indexOf(a.name);
                                const indexB = customSizeOrder.indexOf(b.name);
                                if (indexA === -1 && indexB === -1) return 0;
                                if (indexA === -1) return 1;
                                if (indexB === -1) return -1;
                                return indexA - indexB;
                              })
                              .map((size) => {
                                const entry = amounts.find(
                                  (entry) =>
                                    entry.sizeId === size.id &&
                                    entry.colorId === color.id
                                );
                                const cantidad = entry?.cantidad || 0;
                                const ean = entry?.ean || "";

                                return (
                                  <React.Fragment
                                    key={`${color.id}-${size.id}`}
                                  >
                                    <td className="border py-2 px-1 text-center">
                                      <input
                                        type="number"
                                        min="0"
                                        step="any"
                                        value={cantidad}
                                        onChange={(e) =>
                                          handleInputChange(
                                            size.id,
                                            color.id,
                                            e.target.value,
                                            "amount"
                                          )
                                        }
                                        className="w-full border border-gray-300 rounded-lg p-2 text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="0"
                                      />
                                    </td>
                                    <td className="border py-2 px-3 text-center">
                                      <input
                                        type="text"
                                        value={ean}
                                        onChange={(e) =>
                                          handleInputChange(
                                            size.id,
                                            color.id,
                                            e.target.value,
                                            "ean"
                                          )
                                        }
                                        className="w-full border border-gray-300 rounded-lg p-2 text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="Barcode"
                                      />
                                    </td>
                                  </React.Fragment>
                                );
                              })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Row>
            <br />
            {validaBoton &&
              arrayColores.length > 0 &&
              arrayTallas.length > 0 &&
              amounts.some((entry) => entry.cantidad > 0) ? (
              <Button type="submit" className="btn btn-success">
                Save
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Save
              </Button>
            )}
            <Button
              href="/ListadoPreArticulosChina"
              className="btn btn-danger"
              id="botonListado"
            >
              Back
            </Button>
          </Form>
          <br />

          <Modal size="lg" isOpen={modalColores} toggle={toggleColores}>
            <ModalHeader toggle={toggleColores}>
              <h4>Model Colors {nombre}</h4>
            </ModalHeader>
            <ModalBody>
              {/* Show available colores (unchecked) */}
              {colores
                .filter(
                  (color) =>
                    !arrayColores.some((selected) => selected.id === color._id)
                )
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a) => {
                  return (
                    <table key={a._id}>
                      <tbody>
                        <tr>
                          <td>
                            <Input
                              type="checkbox"
                              key={a._id}
                              onChange={(e) => {
                                coloresSeleccionados(
                                  e.currentTarget.checked,
                                  a
                                );
                              }}
                              className="subMenu"
                            />
                            <h5 className="subMenuTitulo">{a.name}</h5>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  );
                })}

              {/* Show selected colores at the bottom */}
              {arrayColores.length > 0 && (
                <>
                  <hr style={{ margin: "20px 0" }} />
                  <h6 style={{ fontWeight: "bold" }}>Selected Colors:</h6>
                  {arrayColores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((selectedColor) => (
                      <table key={`selected-${selectedColor.id}`}>
                        <tbody>
                          <tr>
                            <td>
                              <Input
                                type="checkbox"
                                checked={true}
                                onChange={(e) => {
                                  coloresSeleccionados(
                                    e.currentTarget.checked,
                                    selectedColor
                                  );
                                }}
                                className="subMenu"
                              />
                              <h5 className="subMenuTitulo">
                                {selectedColor.name}
                              </h5>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    ))}
                </>
              )}
            </ModalBody>
          </Modal>

          <Modal size="lg" isOpen={modalTallas} toggle={toggleTallas}>
            <ModalHeader toggle={toggleTallas}>
              <h4>Model Sizes {nombre}</h4>
            </ModalHeader>
            <ModalBody>
              {/* Show available tallas (unchecked) */}
              {tallas
                .filter(
                  (talla) =>
                    !arrayTallas.some((selected) => selected.id === talla._id)
                )
                .sort((a, b) => {
                  const indexA = customSizeOrder.indexOf(a.name);
                  const indexB = customSizeOrder.indexOf(b.name);

                  if (indexA === -1 && indexB === -1) return 0;
                  if (indexA === -1) return 1;
                  if (indexB === -1) return -1;

                  return indexA - indexB;
                })
                .map((a) => {
                  return (
                    <table key={a._id}>
                      <tbody>
                        <tr>
                          <td>
                            <Input
                              type="checkbox"
                              key={a._id}
                              onChange={(e) => {
                                tallasSeleccionados(e.currentTarget.checked, a);
                              }}
                              className="subMenu"
                            />
                            <h5 className="subMenuTitulo">{a.name}</h5>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  );
                })}

              {/* Show selected tallas at the bottom */}
              {arrayTallas.length > 0 && (
                <>
                  <hr style={{ margin: "20px 0" }} />
                  <h6 style={{ fontWeight: "bold" }}>Selected Sizes:</h6>
                  {arrayTallas
                    .sort((a, b) => {
                      const indexA = customSizeOrder.indexOf(a.name);
                      const indexB = customSizeOrder.indexOf(b.name);

                      if (indexA === -1 && indexB === -1) return 0;
                      if (indexA === -1) return 1;
                      if (indexB === -1) return -1;

                      return indexA - indexB;
                    })
                    .map((selectedTalla) => (
                      <table key={`selected-${selectedTalla.id}`}>
                        <tbody>
                          <tr>
                            <td>
                              <Input
                                type="checkbox"
                                checked={true}
                                onChange={(e) => {
                                  tallasSeleccionados(
                                    e.currentTarget.checked,
                                    selectedTalla
                                  );
                                }}
                                className="subMenu"
                              />
                              <h5 className="subMenuTitulo">
                                {selectedTalla.name}
                              </h5>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    ))}
                </>
              )}
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default PreArticulosChinaCreate;
